import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APProgramDetailsQuery } from '../../../../../plan/queries/ap_program_details_query';
import { AdvisorBlockedSuggestionsQuery } from '../../../../../suggestions/components/blocked_suggestions/queries/blocked_suggestions_query';
import { IFeedbackTermAndSuggestion } from '../../builders/plan_feedback_transaction_builder';
import { AdvisorHeaderDetailsQuery } from '../../queries/advisor_plan_details_query';
import { INotificationDelegate } from './../../../../../global/helpers/notification_delegate';
import { APAdvisorText } from './../../../../../global/servants/ap_advisor_text_servant';
import { AdvisorSentFeedbackDiffQuery } from './../../queries/advisor_sent_feedback_diff_query';
import { AdvisorSentFeedbackGraduationTimeQuery } from './../../queries/advisor_sent_feedback_graduation_time_query';
class PlanFeedbackHeader {
  private programName: string = '';
  private totalSuggestions: number;
  private termsAndSuggestions: IFeedbackTermAndSuggestion[];
  private noOfSuggestionsString: string = '';
  private commentOnly: boolean;
  private advisorLabel: string;
  private showPlannerLeaveConfirmation: boolean = false;
  private showConflictAlert = false;

  constructor(
    private appConfigModel: any,
    private $state: ng.ui.IStateService,
    private ngAPNotificationDelegate: INotificationDelegate,
    private ngAPAdvisorSentFeedbackGraduationTimeQuery: AdvisorSentFeedbackGraduationTimeQuery,
    private ngAPAdvisorSentFeedbackDiffQuery: AdvisorSentFeedbackDiffQuery,
    private ngAPProgramDetailsQuery: APProgramDetailsQuery,
    private ngAPAdvisorHeaderDetailsQuery: AdvisorHeaderDetailsQuery,
    private ngAPAdvisorBlockedSuggestionsQuery: AdvisorBlockedSuggestionsQuery,
    private feedbackAcceptDeclineRevokeHelper: ng.IServiceProviderFactory,
    private phxFeatureConfiguration: any,
    private changeSuggestedPlanStatusCommand: ICommand,
    private ngAPAdvisorText: APAdvisorText
  ) {}
  $onInit() {
    this.programName = this.ngAPProgramDetailsQuery.result.programName;
    this.totalSuggestions = _4.sumBy(
      this.ngAPAdvisorSentFeedbackDiffQuery.result.termsAndSuggestions,
      'suggestions.length'
    );
    this.commentOnly = this.ngAPAdvisorSentFeedbackDiffQuery.result.hasCommentOnly;
  }

  $onChanges() {
    this.totalSuggestions = _4.sumBy(
      this.ngAPAdvisorSentFeedbackDiffQuery.result.termsAndSuggestions,
      'suggestions.length'
    );
    this.advisorLabel = this.ngAPAdvisorText.advisorLabel;
    const plural = this.totalSuggestions > 1 ? 's' : '';
    this.noOfSuggestionsString = `You have ${this.totalSuggestions} suggestion${plural} from your ${this.advisorLabel} on ${this.ngAPAdvisorHeaderDetailsQuery.result.submittedDate}`;
    this.showConflictAlert = !_4.isEmpty(this.ngAPAdvisorBlockedSuggestionsQuery.result.conflictingSuggestions);
  }

  goToExplore() {
    this.showPlannerLeaveConfirmation = true;
  }

  acceptAllSuggestions() {
    const nonTemplateFeedbacks = _4.flatten(
      this.ngAPAdvisorSentFeedbackDiffQuery.result.termsAndSuggestions.map((_suggestion) => _suggestion.suggestions)
    );
    const templateFeedbacks = this.ngAPAdvisorSentFeedbackDiffQuery.result.templateSuggestions;
    this.feedbackAcceptDeclineRevokeHelper(templateFeedbacks.concat(nonTemplateFeedbacks), 'ACCEPT');
  }
  acknowledge() {
    this.changeSuggestedPlanStatusCommand('RESOLVED').then(() => {
      this.ngAPNotificationDelegate.success(`Successfully acknowledged ${this.advisorLabel} suggestions`);
      this.$state.go('my.planner.plan.default');
    });
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackHeader', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_header/plan_feedback_header.html',
  controller: PlanFeedbackHeader
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_header/plan_feedback_header.ts